/**
 * GlobalChrome — universal parchment page chrome.
 *
 * Renders a fixed brass border + 4 corner flourishes + (optionally) the
 * closing "ONE BOOK. ONE IDEA. ONE PRACTICE. ONE TRANSFORMATION." ribbon.
 *
 * Usage:
 *   <div className="parchment-theme">
 *     <GlobalChrome />
 *     ...page content...
 *     <GlobalChromeRibbon />
 *   </div>
 */
import React from "react";
import "../styles/Parchment.css";

function CornerFlourish({ position }) {
  return (
    <svg
      className={`pt-flourish ${position}`}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Outer leafy curve */}
      <path
        d="M2 2 C 28 4, 48 14, 60 28 C 56 24, 50 22, 44 22 C 38 22, 34 26, 32 32 C 30 38, 26 42, 22 44 C 16 46, 10 50, 8 56 C 6 50, 4 44, 2 2 Z"
        fill="url(#leafGrad)"
        opacity="0.9"
      />
      {/* Inner accent stroke */}
      <path
        d="M4 4 C 24 8, 40 16, 52 30"
        stroke="#8B6508"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
      />
      {/* Detail dots */}
      <circle cx="14" cy="6" r="1.5" fill="#D4AF37" />
      <circle cx="22" cy="12" r="1.2" fill="#D4AF37" />
      <circle cx="6" cy="14" r="1.2" fill="#D4AF37" />
      {/* Small leaf accents */}
      <path d="M28 18 C 32 18, 36 22, 36 28" stroke="#8B6508" strokeWidth="0.8" fill="none" />
      <path d="M40 22 C 44 24, 48 28, 50 34" stroke="#8B6508" strokeWidth="0.8" fill="none" />
      <defs>
        <radialGradient id="leafGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 10) rotate(45) scale(70)">
          <stop offset="0%" stopColor="#F3E5AB" />
          <stop offset="60%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#8B6508" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function GlobalChrome() {
  return (
    <div className="pt-chrome" aria-hidden="true" data-testid="pt-chrome">
      <CornerFlourish position="tl" />
      <CornerFlourish position="tr" />
      <CornerFlourish position="bl" />
      <CornerFlourish position="br" />
    </div>
  );
}

export function GlobalChromeRibbon() {
  return (
    <footer className="pt-ribbon" role="contentinfo" data-testid="pt-ribbon">
      <span className="pt-ribbon-text">
        <em>✦</em>
        ONE BOOK. ONE IDEA. ONE PRACTICE. ONE TRANSFORMATION.
        <em>✦</em>
      </span>
    </footer>
  );
}

export default GlobalChrome;
